import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";
import { Zone } from "@common/ADAPT.Common.Model/methodology/zone";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { TeamLocation } from "@common/ADAPT.Common.Model/organisation/team-location";
import { RxjsBreezeService } from "@common/lib/data/rxjs-breeze.service";
import { cacheLatest } from "@common/lib/utilities/rxjs-utilities";
import { CommonTeamsService } from "@org-common/lib/teams/common-teams.service";
import { merge, Observable } from "rxjs";
import { filter, map, startWith, switchMap, tap } from "rxjs/operators";

@Component({
    selector: "adapt-render-organisation-map",
    templateUrl: "render-organisation-map.component.html",
    standalone: false,
})
export class RenderOrganisationMapComponent {
    @Input() public teamTemplate?: TemplateRef<unknown>;
    @Input() public globalZoneLocationTemplate?: TemplateRef<unknown>;
    @Input() public showGlobalZoneLocation = false;
    @Input() public globalZoneLocationLabel = "";
    @Input() public filterTeams?: (teams: Team[]) => Team[] | Observable<Team[]>;
    @Input() public isEditing = false;
    @Output() public loaded = new EventEmitter<void>();

    public teamLocations$: Observable<TeamLocation[]>;
    public showResearchAndDevelopment$: Observable<boolean>;
    public showEconomicEngine$: Observable<boolean>;

    public constructor(
        private commonTeamsService: CommonTeamsService,
        rxjsBreezeService: RxjsBreezeService,
    ) {
        this.teamLocations$ = merge(
            rxjsBreezeService.entityTypeChanged(Team),
            rxjsBreezeService.entityTypeChanged(TeamLocation),
        ).pipe(
            startWith(undefined),
            switchMap(() => this.commonTeamsService.getAllTeamLocations()),
            cacheLatest(),
            tap(() => this.loaded.emit()),
        );

        this.showResearchAndDevelopment$ = this.shouldShowZone(Zone.ResearchAndDevelopment);
        this.showEconomicEngine$ = this.shouldShowZone(Zone.EconomicEngine);
    }

    private shouldShowZone(zone: Zone) {
        return this.teamLocations$.pipe(
            filter(() => !!this.teamTemplate),
            map((allTeamLocations) => allTeamLocations
                .filter((i) => i.zone === zone)
                .map((i) => i.team)),
            // apply team filtering to display as well
            switchMap((teams) => this.commonTeamsService.applyTeamsFilter(teams, this.filterTeams)),
            map((teams) => teams.length > 0),
        );
    }
}
